export const translations = {
  bg: {
    nav: {
      services: "Услуги",
      process: "Процес",
      gallery: "Галерия",
      blog: "Блог",
      faq: "Въпроси",
      contact: "Контакти",
      call: "Обади се",
      menu: "Меню",
    },
    hero: {
      location: "Шумен, България",
      titlePre: "Професионален ремонт на",
      titleAccent: "турбокомпресори",
      subtitle:
        "Гарантирано качество, прецизна настройка на стенд и надеждност за вашия автомобил. Диагностика, ремонт и основен ремонт на всички марки турбини за леки и лекотоварни автомобили.",
      ctaServices: "Нашите услуги",
      stats: [
        { n: "5+", l: "Години опит" },
        { n: "100%", l: "Гаранция" },
        { n: "24ч", l: "Бърза диагностика" },
      ],
      badgeTitle: "Стенд настройка",
      badgeDesc: "Прецизен тест и диагностика на всяка турбина",
      imgAlt: "Турбокомпресор",
    },
    services: {
      eyebrow: "Какво предлагаме",
      heading: "Пълен набор от услуги за турбокомпресори",
      caption: "след ремонт",
      items: [
        {
          title: "Ремонт на турбини",
          desc: "Професионален ремонт на турбокомпресори за леки и лекотоварни автомобили — отстраняване на луфтове, шум, свирене, загуба на мощност и пушене на всички марки турбини.",
        },
        {
          title: "Основен ремонт (Overhaul)",
          desc: "Основен ремонт на турбокомпресор с пълно разглобяване и подмяна на износените лагери, уплътнения и роторни групи с качествени части от MELETT, JRONE и E&E Turbos.",
        },
        {
          title: "Стенд настройка",
          desc: "Прецизна настройка и калибриране на турбината на високотехнологичен стенд G3 min-Flow bench за максимална производителност и надеждност.",
        },
        {
          title: "Диагностика на турбо",
          desc: "Точна диагностика и оценка на състоянието на турбокомпресора и определяне на причината за неизправността — бързо и коректно.",
        },
        {
          title: "Настройка на VNT актуатор",
          desc: "Калибриране и обучение на вакуумни и електронни актуатори (VNT/VGT) с оборудване G3-REA-MASTER за прецизна работа по заводски параметри.",
        },
        {
          title: "Гаранция",
          desc: "Всеки ремонт на турбо е с гаранция. Работим с грижа и отговорност към вашия автомобил. Гаранцията важи само за дефектни части, използвани при ремонта.",
        },
      ],
    },
    process: {
      eyebrow: "Как работим",
      heading: "Прецизен процес в четири стъпки",
      benchTitle: "FLOW BENCH",
      benchDesc: "Настройка на турбо VNT и обучение на електрически актуатори",
      steps: [
        {
          title: "Диагностика",
          desc: "Приемаме турбината и извършваме подробна диагностика за установяване на всички неизправности.",
        },
        {
          title: "Разглобяване",
          desc: "Внимателно разглобяване и почистване на всеки компонент за детайлна проверка.",
        },
        {
          title: "Ремонт и части",
          desc: "Подмяна на износени лагери, уплътнения и роторни групи с качествени оригинални части. Използваме само части от марките: MELETT, JRONE и E&E Turbos.",
        },
        {
          title: "Финален тест",
          desc: "Прецизно калиброване и настройка на стенд преди предаване на клиента. Издаване на протокол от теста за съответното турбо.",
        },
      ],
    },
    actuator: {
      eyebrow: "Специализирана услуга",
      heading: "Настройка ел. актуатори",
      body: "Разполагаме със специализирано мобилно оборудване G3-REA-MASTER ( touch ) за обучение и калибриране на електронни актуатори (VNT/VGT) на турбокомпресорите. Всеки актуатор се настройва и тества според заводските параметри на конкретната турбина. Това гарантира точна работа, правилно налягане и оптимална производителност на двигателя.",
      imgAlt: "Настройка на електронни актуатори",
    },
    gallery: {
      eyebrow: "Нашата работа",
      heading: "Галерия и работилница",
    },
    brands: {
      eyebrow: "Марки, които ремонтираме",
      heading: "Работим с всички водещи марки турбини",
    },
    faq: {
      eyebrow: "Често задавани въпроси",
      heading: "Всичко за ремонта на турбокомпресори",
      items: [
        {
          q: "Колко струва ремонт на турбина (турбокомпресор)?",
          a: "Цената зависи от състоянието на турбината и необходимите части. Извършваме безплатна диагностика, а окончателната цена за ремонт се обявява след пълната дефектация на турбото в сервиза. Свържете се с нас за предварителна ориентировъчна цена.",
        },
        {
          q: "Колко време отнема ремонтът на турбокомпресор?",
          a: "При наличие на необходимите части повечето ремонти и основни ремонти (overhaul) отнемат между 1 и 3 работни дни. След ремонта всяка турбина преминава финален тест и калибриране на стенд преди предаване.",
        },
        {
          q: "Какви марки турбокомпресори ремонтирате?",
          a: "Ремонтираме турбини на всички марки за леки и лекотоварни автомобили — Garrett, BorgWarner / KKK, Continental, Mitsubishi, IHI, Holset и др. Използваме само качествени части от MELETT, JRONE и E&E Turbos.",
        },
        {
          q: "Какво включва основният ремонт (overhaul) на турбина?",
          a: "Основният ремонт включва пълно разглобяване, почистване, подмяна на износени лагери, уплътнения и роторни групи с оригинални части, прецизно балансиране и финален тест на стенд за максимална надеждност и производителност.",
        },
        {
          q: "Какво е настройка на VNT / VGT актуатор и защо е важна?",
          a: "При турбините с променлива геометрия (VNT/VGT) минималният поток и позицията на актуатора трябва да са настроени по заводски параметри. Разполагаме със специализирано оборудване G3-REA-MASTER и G3 min-Flow bench за обучение и калибриране на електронни актуатори — това предотвратява загуба на мощност, пушене и грешки.",
        },
        {
          q: "Как да разбера, че турбината ми е повредена?",
          a: "Най-честите признаци са: син или черен дим от ауспуха, свирене/съскане от турбината, загуба на мощност, повишен разход на масло и грешки в двигателя. При такива симптоми е препоръчителна навременна диагностика.",
        },
        {
          q: "Давате ли гаранция за извършения ремонт?",
          a: "Да, всеки ремонт на турбокомпресор е с гаранция. Гаранцията важи само за дефектни части, използвани при ремонта. Работим коректно и с отговорност към вашия автомобил.",
        },
      ],
    },
    blog: {
      eyebrow: "Полезно за клиента",
      heading: "Блог и съвети за турбо",
      read: "Прочети",
    },
    contact: {
      eyebrow: "Свържете се с нас",
      headingPre: "За ",
      headingAccent: "предварителна цена",
      headingPost: " и време за изпълнение",
      body: "Обадете се за безплатна консултация и оценка на вашата турбина. Окончателната цена за ремонт се обявява след пълната дефектация на турбото в сервиза. Работим бързо, коректно и с гаранция.",
      phoneLabel: "Телефон",
      emailLabel: "Имейл",
      addressLabel: "Адрес",
      addressLine1: "ул. Индустриална 58, Южна индустриална зона",
      addressLine2: "9704 Шумен, България",
      hoursLabel: "Работно време",
      hoursWeek: "Понеделник – Петък: 09:00 – 17:30",
      hoursWeekend: "Събота и Неделя: Почивни дни",
      navigate: "Навигация",
      mapTitle: "Карта — RM Турбо сервиз Шумен",
    },
    footer: {
      brand: "Турбо сервиз",
      city: "Шумен",
      location: "Шумен, България",
      rights: "Всички права запазени.",
    },
    blogPost: {
      back: "Всички статии",
      notFound: "Статията не е намерена",
      backHome: "← Обратно към сайта",
      ctaTitle: "Нуждаете се от ремонт на турбина?",
      ctaBody: "Свържете се с RM Турбо сервиз - Шумен за безплатна консултация и диагностика.",
      otherPosts: "Още статии",
    },
    locale: "bg-BG",
  },

  en: {
    nav: {
      services: "Services",
      process: "Process",
      gallery: "Gallery",
      blog: "Blog",
      faq: "FAQ",
      contact: "Contact",
      call: "Call now",
      menu: "Menu",
    },
    hero: {
      location: "Shumen, Bulgaria",
      titlePre: "Professional repair of",
      titleAccent: "turbochargers",
      subtitle:
        "Guaranteed quality, precise bench calibration and reliability for your vehicle. Diagnostics, repair and overhaul of all turbo brands for cars and light commercial vehicles.",
      ctaServices: "Our services",
      stats: [
        { n: "5+", l: "Years of experience" },
        { n: "100%", l: "Warranty" },
        { n: "24h", l: "Fast diagnostics" },
      ],
      badgeTitle: "Bench calibration",
      badgeDesc: "Precise testing and diagnostics of every turbo",
      imgAlt: "Turbocharger",
    },
    services: {
      eyebrow: "What we offer",
      heading: "A complete range of turbocharger services",
      caption: "after repair",
      items: [
        {
          title: "Turbine repair",
          desc: "Professional repair of turbochargers for cars and light commercial vehicles — eliminating play, noise, whistling, power loss and smoking on all turbo brands.",
        },
        {
          title: "Complete overhaul",
          desc: "Full turbocharger overhaul with complete disassembly and replacement of worn bearings, seals and rotor groups using quality parts from MELETT, JRONE and E&E Turbos.",
        },
        {
          title: "Bench calibration",
          desc: "Precise calibration and adjustment of the turbo on a high-tech G3 min-Flow bench for maximum performance and reliability.",
        },
        {
          title: "Turbo diagnostics",
          desc: "Accurate diagnostics and assessment of the turbocharger's condition and identification of the cause of the fault — fast and reliable.",
        },
        {
          title: "VNT actuator setup",
          desc: "Calibration and training of vacuum and electronic actuators (VNT/VGT) with G3-REA-MASTER equipment for precise operation to factory parameters.",
        },
        {
          title: "Warranty",
          desc: "Every turbo repair comes with a warranty. We work with care and responsibility for your vehicle. The warranty applies only to defective parts used in the repair.",
        },
      ],
    },
    process: {
      eyebrow: "How we work",
      heading: "A precise four-step process",
      benchTitle: "FLOW BENCH",
      benchDesc: "VNT turbo setup and electronic actuator training",
      steps: [
        {
          title: "Diagnostics",
          desc: "We receive the turbo and perform a detailed diagnostic to identify all faults.",
        },
        {
          title: "Disassembly",
          desc: "Careful disassembly and cleaning of every component for a detailed inspection.",
        },
        {
          title: "Repair & parts",
          desc: "Replacement of worn bearings, seals and rotor groups with quality original parts. We use only parts from the brands: MELETT, JRONE and E&E Turbos.",
        },
        {
          title: "Final test",
          desc: "Precise calibration and bench adjustment before delivery to the customer. Issuing a test report for the specific turbo.",
        },
      ],
    },
    actuator: {
      eyebrow: "Specialized service",
      heading: "Electronic actuator setup",
      body: "We have specialized mobile G3-REA-MASTER (touch) equipment for training and calibrating the electronic actuators (VNT/VGT) of turbochargers. Each actuator is set and tested according to the factory parameters of the specific turbo. This ensures accurate operation, correct pressure and optimal engine performance.",
      imgAlt: "Electronic actuator setup",
    },
    gallery: {
      eyebrow: "Our work",
      heading: "Gallery & workshop",
    },
    brands: {
      eyebrow: "Brands we repair",
      heading: "We work with all leading turbo brands",
    },
    faq: {
      eyebrow: "Frequently asked questions",
      heading: "Everything about turbocharger repair",
      items: [
        {
          q: "How much does turbocharger repair cost?",
          a: "The price depends on the turbo's condition and the parts required. We offer free diagnostics, and the final repair price is set after a full inspection of the turbo at our workshop. Contact us for a preliminary estimate.",
        },
        {
          q: "How long does a turbocharger repair take?",
          a: "When the required parts are available, most repairs and overhauls take between 1 and 3 working days. After the repair, every turbo undergoes a final test and bench calibration before delivery.",
        },
        {
          q: "Which turbocharger brands do you repair?",
          a: "We repair turbos of all brands for cars and light commercial vehicles — Garrett, BorgWarner / KKK, Continental, Mitsubishi, IHI, Holset and more. We use only quality parts from MELETT, JRONE and E&E Turbos.",
        },
        {
          q: "What does a turbo overhaul include?",
          a: "A complete overhaul includes full disassembly, cleaning, replacement of worn bearings, seals and rotor groups with original parts, precise balancing and a final bench test for maximum reliability and performance.",
        },
        {
          q: "What is VNT / VGT actuator setup and why is it important?",
          a: "On variable-geometry turbos (VNT/VGT), the minimum flow and actuator position must be set to factory parameters. We have specialized G3-REA-MASTER and G3 min-Flow bench equipment for training and calibrating electronic actuators — this prevents power loss, smoking and errors.",
        },
        {
          q: "How do I know my turbo is damaged?",
          a: "The most common signs are: blue or black smoke from the exhaust, whistling/hissing from the turbo, power loss, increased oil consumption and engine errors. If you notice these symptoms, timely diagnostics is recommended.",
        },
        {
          q: "Do you provide a warranty for the repair?",
          a: "Yes, every turbocharger repair comes with a warranty. The warranty applies only to defective parts used in the repair. We work correctly and responsibly with your vehicle.",
        },
      ],
    },
    blog: {
      eyebrow: "Useful for customers",
      heading: "Blog & turbo tips",
      read: "Read",
    },
    contact: {
      eyebrow: "Contact us",
      headingPre: "For a ",
      headingAccent: "preliminary price",
      headingPost: " and turnaround time",
      body: "Call for a free consultation and assessment of your turbo. The final repair price is announced after a full inspection of the turbo at our workshop. We work fast, correctly and with a warranty.",
      phoneLabel: "Phone",
      emailLabel: "Email",
      addressLabel: "Address",
      addressLine1: "58 Industrialna St., South Industrial Zone",
      addressLine2: "9704 Shumen, Bulgaria",
      hoursLabel: "Working hours",
      hoursWeek: "Monday – Friday: 09:00 – 17:30",
      hoursWeekend: "Saturday & Sunday: Closed",
      navigate: "Navigate",
      mapTitle: "Map — RM Turbo Service Shumen",
    },
    footer: {
      brand: "Turbo Service",
      city: "Shumen",
      location: "Shumen, Bulgaria",
      rights: "All rights reserved.",
    },
    blogPost: {
      back: "All articles",
      notFound: "Article not found",
      backHome: "← Back to site",
      ctaTitle: "Need a turbo repair?",
      ctaBody: "Contact RM Turbo Service - Shumen for a free consultation and diagnostics.",
      otherPosts: "More articles",
    },
    locale: "en-US",
  },
};
